import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import {MedicareDisclaimersModal} from './MedicareDisclaimersModal';
import {SxProps} from '@mui/material';
import { useMaPlansCount } from '@coverright/data-access/medicare';
import { getMultiplan } from '@coverright/utils';

function Func(props: PropsWithChildren<{sx?: SxProps, hideMultiplan?: boolean, zip?: string, pdp?: boolean, type?: 'U_M' | '_M'}>) {
  const [openDisclaimer, setOpenDisclaimer] = React.useState(false);
  const maZip = props.pdp ? undefined : props.zip;
  const pdpZip = props.pdp ? props.zip : undefined;
  const { maPlansCount, maOrgCount, pdpOrgCount, pdpPlansCount } = useMaPlansCount(maZip || pdpZip);

  const orgCount = props.pdp ? pdpOrgCount : maOrgCount;
  const plansCount = props.pdp ? pdpPlansCount : maPlansCount;

  return <Box sx={{maxWidth: 800, ...props.sx}} mt={'50px'}>
    <MedicareDisclaimersModal open={openDisclaimer} onClose={() => setOpenDisclaimer(false)} plansCount={plansCount} orgCount={orgCount}/>
    <Typography color={'textPrimary'} className={'bold pointer fs-14'}
                style={{textDecoration: 'underline', width: 'fit-content'}} onClick={() => setOpenDisclaimer(true)}>
      View Medicare Disclaimers
    </Typography>
    <Box sx={{my: '10px', gap: 2, display: 'flex', flexDirection: 'column'}}>
      <Typography className={'fs-12'} color={'textPrimary'}>
        If you need help, please call +1 (888) 969-7667 (TTY: 711) Mon-Fri 8am-10pm (ET), Sat-Sun 9am-7pm (ET) for licensed CoverRight sales agents who can assist with finding information on available Medicare Advantage, Medicare Supplement (Medigap) Insurance and Prescription Drug Plans.
      </Typography>
      <Typography className={'fs-12'} color={'textPrimary'}>
        CoverRight Insurance Services Inc. represents Medicare Advantage HMO,
        PPO and PFFS organizations and stand-alone PDP prescription drug plans that have a Medicare contract.
        Enrollment depends on the plan’s contract renewal with Medicare.
      </Typography>
      <Typography className={'fs-12'} color={'textPrimary'}>
        We do not offer every plan available in your area. {(!!maPlansCount || !!pdpPlansCount) && <>Currently we represent {orgCount} organizations which
        offer {plansCount} products in your area.</>} Please contact Medicare.gov, 1–800–MEDICARE to get information on all of your options.
      </Typography>
      <Typography className={'fs-12'} color={'textPrimary'}>
        For a complete list of available plans please contact 1-800-MEDICARE (1-800-633-4227). TTY/RTT users should call 1-877-486-2048, 24 hours a day/7 days a week or consult Medicare.gov.
      </Typography>
      <Typography className={'fs-12'} color={'textPrimary'}>
        Medicare beneficiaries can file a complaint with the Centers for Medicare & Medicaid Services by calling 1-800-MEDICARE 24 hours a day/7 days a week or using the medicare.gov site.
      </Typography>
      <Typography className={'fs-12'} color={'textPrimary'}>
        Enrollment in a plan may be limited to certain times of the year unless you qualify for a Special Enrollment Period or you are in your Medicare Initial Enrollment Period.
      </Typography>
      {props.children}
    </Box>
    <Typography className={'fs-12'} color={'textPrimary'}>
      Last Updated Date: 9/17/2026<br/>{!props.hideMultiplan && getMultiplan(props.type)}
    </Typography>

  </Box>
}

export const MarketplaceDisclamers = React.memo(Func)
